export const unityStartContext = () => {
  (window as { [key: string]: any })["StartUnityContext"] = async () => {
    // setTimeout(() => {
    //   (window as any).addAvatar();
    // }, 1000);
  };
};
